import React from "react";

import DialogTitle from "@busbud/design-system-components/dist/DialogTitle";

import { useTitleStyles } from "./cancel-dialog.styles";

export interface CancelDialogTitleProps {
  children: React.ReactNode;
  title_icon?: React.ReactNode;
  classes?: Partial<Record<"root", string>>;
  onClose?: () => void;
}

export const CancelDialogTitle: React.FC<CancelDialogTitleProps> = props => {
  const { children, title_icon, classes: external_classes, onClose } = props;
  const { classes: dialog_title_classes } = useTitleStyles();
  const classes = external_classes || dialog_title_classes;

  return (
    <DialogTitle className={classes.root} onClose={onClose}>
      <span>{children}</span>
      {!!title_icon && <span>{title_icon}</span>}
    </DialogTitle>
  );
};
